import { generatePaginationLinks } from "../../../../utils/GeneratePaginationLinkgs";
import { Spinner } from "../../../shared";
import TablaAtrasos from "./tablas/tabla";
import "../../../shared/styles/ViewContainer.css";

const ReporteAtrasos = ({ onClick, onChange, data, loading, sort, params }) => {
  return (
    <div className="view-container">
      <div className="view-header">
        <h3 className="view-title">REPORTES DE ATRASOS</h3>
      </div>

      <div className="view-search">
        <div className="search-group">
          <i className="bi bi-search search-icon"></i>
          <input
            type="text"
            className="search-input"
            id="input-search"
            placeholder="Buscar por persona"
            name="search"
            onKeyUp={(e) => {
              if (e.code === "Enter") {
                onChange(e, e.target.value);
              }
            }}
          />
        </div>
      </div>

      <div className="view-content">
        {loading ? (
          <Spinner />
        ) : (
          <div>
            <div className="pagination-container fade-in">
              <div className="pagination-info">
                Total: {data?.total} registros
              </div>
              <div className="pagination-buttons">
                <button
                  className="pagination-btn"
                  name="anterior"
                  onClick={(event) => onClick(event)}
                  disabled={data?.current_page === 1}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                {generatePaginationLinks(data).map((l, index) => {
                  return (
                    <button
                      key={index}
                      className={
                        l.label == data?.current_page
                          ? "pagination-btn pagination-btn-active"
                          : "pagination-btn"
                      }
                      name="link"
                      onClick={(event) => onClick(event, l.label)}
                    >
                      {l.label}
                    </button>
                  );
                })}
                <button
                  className="pagination-btn"
                  name="siguiente"
                  onClick={(event) => onClick(event)}
                  disabled={data?.current_page === data?.last_page}
                >
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>

            <TablaAtrasos
              onClick={onClick}
              onChange={onChange}
              data={data?.data}
              sort={sort}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReporteAtrasos;
